import { render, staticRenderFns } from "./FooterMedia.vue?vue&type=template&id=19b24da4&scoped=true&"
import script from "./FooterMedia.vue?vue&type=script&lang=js&"
export * from "./FooterMedia.vue?vue&type=script&lang=js&"
import style0 from "./FooterMedia.vue?vue&type=style&index=0&id=19b24da4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b24da4",
  null
  
)

export default component.exports